import React, { useState } from 'react';

interface YoungStarsSectionProps {
  enabled: boolean;
  title: string;
  logoUrl: string;
  content: string;
  gallery: string[];
}

const YoungStarsSection: React.FC<YoungStarsSectionProps> = ({
  enabled,
  title,
  logoUrl,
  content,
  gallery
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  if (!enabled || !title) {
    return null;
  }

  return (
    <section id="youngstars" className="py-16 transition-colors" style={{ backgroundColor: 'var(--bg-secondary)' }}>
      <div className="container mx-auto px-4">
        {/* Logo (zentriert) */}
        {logoUrl && (
          <div className="flex justify-center mb-8">
            <img 
              src={logoUrl} 
              alt={title}
              className="max-w-xs w-full h-auto object-contain"
            />
          </div>
        )}
        
        {/* Title */}
        <h2 className="text-3xl font-bold text-[var(--primary-color)] mb-8 text-center">
          {title}
        </h2>
        
        {/* Content */}
        {content && (
          <div className="max-w-3xl mx-auto mb-12 space-y-4 text-center" style={{ color: 'var(--text-primary)' }}>
            {content.split('\n').map((paragraph, index) => (
              paragraph.trim() && <p key={index} className="mb-4">{paragraph}</p>
            ))}
          </div>
        )}
        
        {/* Gallery - Zentriert wie Hauptgalerie */}
        {gallery && gallery.length > 0 && (
          <div className={
            gallery.length === 1
              ? "flex justify-center"
              : gallery.length === 2
                ? "flex justify-center gap-8"
                : gallery.length === 3
                  ? "flex justify-center gap-8"
                  : "flex flex-wrap justify-center gap-8"
          }>
            {gallery.map((imageUrl, index) => (
              <div
                key={index}
                className={(gallery.length === 1 ? "max-w-[360px] w-full" : "w-[360px]") + " cursor-pointer"}
                onClick={() => setSelectedImage(imageUrl)}
              >
                <img
                  src={imageUrl}
                  alt={`${title} Bild ${index + 1}`}
                  className="w-full h-64 object-cover rounded-lg shadow-md hover:opacity-90 transition-opacity"
                />
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* Lightbox */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="max-w-4xl w-full">
            <img 
              src={selectedImage} 
              alt="Vergrößerte Ansicht"
              className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default YoungStarsSection;


